import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { Observable, of, timer, map, interval } from 'rxjs';

@Pipe({
  name: 'countdown'
})
export class CountdownPipe implements PipeTransform {
  transform(targetDate: Date): Observable<string> {
		if (!targetDate) return of('00:00:00');
		return timer(0, 1000).pipe(
			map(() => {
				const diff = moment(targetDate).diff(moment(), 'seconds', true);
				return this.numberToTimeDisplay(diff);
			})
		);
	}

	numberToTimeDisplay(time: number): string {
		if (!time || time <= 0) return '00:00:00';
		return new Date(1000 * time).toISOString().substr(11, 8);
	}
}